import { api } from '@/shared/api'
import { InviteLink } from '@synapex/prisma/client'
import {
    UpdateInviteLinkDto,
    GenerateInviteLinkDto,
    DeleteInviteLinkResponse,
    MoveInviteLinksDto,
} from '@synapex/shared'
import { InviteLinkWithAnalyticsType } from '@/shared/api'
// import { Link } from '@synapex/shared2/gateway-rest-api'

class InviteLinksService {
    async deleteInviteLink(id: number): Promise<DeleteInviteLinkResponse> {
        return await api.delete(`/telegram/invite-links/${id}`)
    }

    async updateInviteLink(data: UpdateInviteLinkDto): Promise<InviteLink> {
        const response: InviteLink = await api.put(
            '/telegram/invite-links',
            data
        )
        return response
    }

    async generateInviteLink(
        data: GenerateInviteLinkDto
    ): Promise<InviteLinkWithAnalyticsType> {
        return await api.post('/telegram/invite-links', data)
    }

    // async getInviteLinksByGroupId(
    //     groupId: number,
    //     channelId: number
    // ): Promise<Link.ChannelLinkManyReply> {
    //     return await api.get(`/link/channel`, {
    //         params: {
    //             groupId,
    //             channelId,
    //         },
    //     })
    // }

    async moveInviteLinks(moveDto: MoveInviteLinksDto): Promise<any> {
        return await api.post('/analytics/invite-links/move-group', moveDto)
    }

    async addAdminContact(
        inviteLinkId: number,
        telegramUsername: string,
        shouldSelectAdmin?: boolean
    ): Promise<any> {
        return await api.post(
            `/telegram/invite-links/${inviteLinkId}/admin-contacts`,
            { telegramUsername, shouldSelectAdmin }
        )
    }

    async deleteAdminContact(
        inviteLinkId: number,
        adminContactId: number
    ): Promise<any> {
        return await api.delete(
            `/telegram/invite-links/${inviteLinkId}/admin-contacts/${adminContactId}`
        )
    }
}

export const inviteLinksService = new InviteLinksService()
